import { tWithKeyAttr as t } from "../../i18nHelper";
import React from "react";
import { userCategories } from "../../utils/categories";
import { Link } from "react-router-dom";

function UsersCategoriesPage() {
  return (
    <section className={`menuSection`} data-testid="users-section">
      <ul className={`options`}>
        {userCategories.map((cat) => (
          <Link
            to={`${cat.value}`}
            key={cat.value}
            className={`option hover`}
            data-testid={`users-category-${cat.value}`}
          >
            {t(cat.label)}
          </Link>
        ))}
      </ul>
    </section>
  );
}

export default UsersCategoriesPage;
